<div class="width-1100">

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>supervised_user_circle</mat-icon>
        <div>GN1 Work</div>
      </div>

      <div flex justify-content='flex-end' fxLayoutAlign="end">
        <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro'
          autocomplete="off">

        <!--
    
        <input id='selectedFile' style="display: none;" #file type="file" accept='*/pdf'
          (change)="readCSVFormation($event)" />
        <a mat-button style='width:60px;' onclick="document.getElementById('selectedFile').click();">
          <mat-icon class='icon-add'>cloud_upload</mat-icon>
        </a>

        <a mat-button (click)="updateSBCCV()" style='width:60px; margin-left:10px;'>
          <mat-icon color='primary'>add_circle_outline</mat-icon>
        </a>
        -->

      </div>

    </mat-toolbar>
  </mat-card>

  <mat-card>



    <mat-tab-group>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>face</mat-icon>
          <div>Ativos</div>
        </ng-template>

        <!--
    <div>
      <a mat-button style='width:100%; margin: 0 0 10px 0;' (click)='validation()'>
        Validar CPF
        <mat-icon class='icon-add'>not_started</mat-icon>
      </a>
    </div>
    -->

        <!-- TABLE -->
        <mat-table [dataSource]="dataSource" matSort matSortDisableClear=false>

          <!-- (matSortChange)="sortData($event)"-->

          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Nome </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.name }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="data1">
            <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
            <mat-cell *matCellDef="let element">

              <div class="data-line-wrapper">
                <div class="data-line">
                  <div class="data-label">Categoria</div>
                  <div class="data-value">
                    <img *ngIf="element.category_ok" src='/assets/images/status/img_green.png'><img
                      *ngIf="!element.category_ok" src='/assets/images/status/img_red.png'>
                    {{element.category}}
                  </div>
                </div>

                <div class="data-line">
                  <div class="data-label">Situação</div>
                  <div class="data-value">
                    <img *ngIf="element.situation_ok" src='/assets/images/status/img_green.png'><img
                      *ngIf="!element.situation_ok" src='/assets/images/status/img_red.png'>
                    {{element.situation}}
                  </div>
                </div>

                <div class="data-line">
                  <div class="data-label">CPF</div>
                  <div class="data-value">
                    <img *ngIf="element.cpf_ok" src='/assets/images/status/img_green.png'><img *ngIf="!element.cpf_ok"
                      src='/assets/images/status/img_red.png'>
                    {{element.cpf}}
                  </div>
                </div>

                <div class="data-line">
                  <div class="data-label">Email</div>
                  <div class="data-value">
                    <img *ngIf="element.email_ok" src='/assets/images/status/img_green.png'><img
                      *ngIf="!element.email_ok" src='/assets/images/status/img_red.png'>
                    {{element.email}}
                  </div>
                </div>

                <div class="data-line">
                  <div class="data-label">Email2</div>
                  <div class="data-value">
                    <img *ngIf="element.email2_ok" src='/assets/images/status/img_green.png'><img
                      *ngIf="!element.email2_ok" src='/assets/images/status/img_red.png'>
                    {{element.email2}}
                  </div>
                </div>

                <div class="data-line">
                  <div class="data-label">Gênero</div>
                  <div class="data-value">
                    <img *ngIf="element.gender_ok" src='/assets/images/status/img_green.png'><img
                      *ngIf="!element.gender_ok" src='/assets/images/status/img_red.png'>
                    {{element.gender}}
                  </div>
                </div>

                <div class="data-line">
                  <div class="data-label">Dt Filiação</div>
                  <div class="data-value">
                    <img *ngIf="element.filiationDate_ok" src='/assets/images/status/img_green.png'><img
                      *ngIf="!element.filiationDate_ok" src='/assets/images/status/img_red.png'>
                    {{element.filiationDate}}
                  </div>
                </div>

                <div class="data-line">
                  <div class="data-label">Dt Nasc.</div>
                  <div class="data-value">
                    <img *ngIf="element.birthDate_ok" src='/assets/images/status/img_green.png'><img
                      *ngIf="!element.birthDate_ok" src='/assets/images/status/img_red.png'>
                    {{element.birthDate}}
                  </div>
                </div>

                <div class="data-line">
                  <div class="data-label">Dt Título</div>
                  <div class="data-value">
                    <img *ngIf="element.titleDate_ok" src='/assets/images/status/img_green.png'><img
                      *ngIf="!element.titleDate_ok" src='/assets/images/status/img_red.png'>
                    {{element.titleDate}}
                  </div>
                </div>

                <div class="data-line">
                  <div class="data-label">RG</div>
                  <div class="data-value">
                    <img *ngIf="element.rg_ok" src='/assets/images/status/img_green.png'><img *ngIf="!element.rg_ok"
                      src='/assets/images/status/img_red.png'>
                    {{element.rg}}
                  </div>
                </div>

                <div class="data-line">
                  <div class="data-label">CRM</div>
                  <div class="data-value">
                    <img *ngIf="element.crm_ok" src='/assets/images/status/img_green.png'><img *ngIf="!element.crm_ok"
                      src='/assets/images/status/img_red.png'>
                    {{element.crm}}
                  </div>
                </div>

                <div class="data-line">
                  <div class="data-label">Celular</div>
                  <div class="data-value">
                    <img *ngIf="element.cellPhone_ok" src='/assets/images/status/img_green.png'><img
                      *ngIf="!element.cellPhone_ok" src='/assets/images/status/img_red.png'>
                    {{element.cellPhone}}
                  </div>
                </div>

                <div class="data-line">
                  <div class="data-label">Fax</div>
                  <div class="data-value">
                    <img *ngIf="element.faxPhone_ok" src='/assets/images/status/img_green.png'><img
                      *ngIf="!element.faxPhone_ok" src='/assets/images/status/img_red.png'>
                    {{element.faxPhone}}
                  </div>
                </div>

                <div class="data-line">
                  <div class="data-label">Clinica</div>
                  <div class="data-value">
                    <img *ngIf="element.clinicPhone_ok" src='/assets/images/status/img_green.png'><img
                      *ngIf="!element.clinicPhone_ok" src='/assets/images/status/img_red.png'>
                    {{element.clinicPhone}}
                  </div>
                </div>

              </div>

            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="data2">
            <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
            <mat-cell *matCellDef="let element">

              <div class="data-line-wrapper">

                <div class="data-line">
                  <div class="data-label">Hospital</div>
                  <div class="data-value">
                    <img *ngIf="element.hospitalPhone_ok" src='/assets/images/status/img_green.png'><img
                      *ngIf="!element.hospitalPhone_ok" src='/assets/images/status/img_red.png'>
                    {{element.hospitalPhone}}
                  </div>
                </div>

                <div class="data-line">
                  <div class="data-label">Auxiliar 1</div>
                  <div class="data-value">
                    <img *ngIf="element.auxPhone1_ok" src='/assets/images/status/img_green.png'><img
                      *ngIf="!element.auxPhone1_ok" src='/assets/images/status/img_red.png'>
                    {{element.auxPhone1}}
                  </div>
                </div>

                <div class="data-line">
                  <div class="data-label">Auxiliar 2</div>
                  <div class="data-value">
                    <img *ngIf="element.auxPhone2_ok" src='/assets/images/status/img_green.png'><img
                      *ngIf="!element.auxPhone2_ok" src='/assets/images/status/img_red.png'>
                    {{element.auxPhone2}}
                  </div>
                </div>


                <div class="data-line">
                  <div class="data-label">Regional</div>
                  <div class="data-value">
                    <img *ngIf="element.regional_ok" src='/assets/images/status/img_green.png'><img
                      *ngIf="!element.regional_ok" src='/assets/images/status/img_red.png'>
                    {{element.regional}}
                  </div>
                </div>

                <div class="data-line">
                  <div class="data-label">Estado</div>
                  <div class="data-value">
                    <img *ngIf="element.state_ok" src='/assets/images/status/img_green.png'><img
                      *ngIf="!element.state_ok" src='/assets/images/status/img_red.png'>
                    {{element.state}}
                  </div>
                </div>

                <div class="data-line">
                  <div class="data-label">Cidade</div>
                  <div class="data-value">
                    <img *ngIf="element.city_ok" src='/assets/images/status/img_green.png'><img *ngIf="!element.city_ok"
                      src='/assets/images/status/img_red.png'>
                    {{element.city}}
                  </div>
                </div>

                <div class="data-line">
                  <div class="data-label">Bairro</div>
                  <div class="data-value">
                    <img *ngIf="element.district_ok" src='/assets/images/status/img_green.png'><img
                      *ngIf="!element.district_ok" src='/assets/images/status/img_red.png'>
                    {{element.district}}
                  </div>
                </div>

                <div class="data-line">
                  <div class="data-label">Rua/Av</div>
                  <div class="data-value">
                    <img *ngIf="element.address_ok" src='/assets/images/status/img_green.png'><img
                      *ngIf="!element.address_ok" src='/assets/images/status/img_red.png'>
                    {{element.address.substring(0,26)}} <span *ngIf="element.address">...</span>
                  </div>
                </div>

                <div class="data-line">
                  <div class="data-label">Número</div>
                  <div class="data-value">
                    <img *ngIf="element.number_ok" src='/assets/images/status/img_green.png'><img
                      *ngIf="!element.number_ok" src='/assets/images/status/img_red.png'>
                    {{element.number}}
                  </div>
                </div>

                <div class="data-line">
                  <div class="data-label">Compl.</div>
                  <div class="data-value">
                    <img *ngIf="element.complement_ok" src='/assets/images/status/img_green.png'><img
                      *ngIf="!element.complement_ok" src='/assets/images/status/img_red.png'>
                    {{element.complement}}
                  </div>
                </div>

                <div class="data-line">
                  <div class="data-label">CEP</div>
                  <div class="data-value">
                    <img *ngIf="element.postalCode_ok" src='/assets/images/status/img_green.png'><img
                      *ngIf="!element.postalCode_ok" src='/assets/images/status/img_red.png'>
                    {{element.postalCode}}
                  </div>
                </div>

                <div class="data-line">
                  <div class="data-label">Residência</div>
                  <div class="data-value">
                    <img *ngIf="element.institute_ok" src='/assets/images/status/img_green.png'><img
                      *ngIf="!element.institute_ok" src='/assets/images/status/img_red.png'>
                    {{element.institute.substring(0,26)}} <span *ngIf="element.institute">...</span>
                  </div>
                </div>

                <div class="data-line">
                  <div class="data-label">Início</div>
                  <div class="data-value">
                    <img *ngIf="element.institute_begin_ok" src='/assets/images/status/img_green.png'><img
                      *ngIf="!element.institute_begin_ok" src='/assets/images/status/img_red.png'>
                    {{element.institute_begin}}
                  </div>
                </div>

                <div class="data-line">
                  <div class="data-label">Término</div>
                  <div class="data-value">
                    <img *ngIf="element.institute_end_ok" src='/assets/images/status/img_green.png'><img
                      *ngIf="!element.institute_end_ok" src='/assets/images/status/img_red.png'>
                    {{element.institute_end}}
                  </div>
                </div>

              </div>

            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='openDialog(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-info' style='font-size:1.5em;'>
                  info_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <!-- Header -->
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

        </mat-table>
        <!-- END TABLE -->

        <mat-paginator [pageSizeOptions]="[6, 12, 24, 48]"></mat-paginator>

      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>face_retouching_off</mat-icon>
          <div>Excluidos</div>
        </ng-template>

        <!-- TABLE -->
        <mat-table [dataSource]="dataSourceExcluded">

          <!-- (matSortChange)="sortData($event)"-->

          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.name }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="category">
            <mat-header-cell *matHeaderCellDef> Categoria </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.category }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="cpf">
            <mat-header-cell *matHeaderCellDef> CPF </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.cpf }}
            </mat-cell>
          </ng-container>


          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='openDialogExcluded(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-info' style='font-size:1.5em;'>
                  info_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <!-- Header -->
          <mat-header-row *matHeaderRowDef="displayedExcludedColumns"></mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: displayedExcludedColumns;"></mat-row>

        </mat-table>
        <!-- END TABLE -->


      </mat-tab>

    </mat-tab-group>


  </mat-card>


</div>